import React from 'react';
import { observer } from 'mobx-react-lite';

import { ListPrice } from './ListPrice';
import { OrderTotalReviewStore } from '../order-total-review/OrderTotalReviewStore';

interface Props {
  store: OrderTotalReviewStore;
}

export const OrderTotalTaxCard = observer<Props>(({ store }) => {
  return (
    <>
      <hr className="mt-0 mb-1" />
      <ListPrice price={store.taxableAmount} label="TaxableAmount" />

      <ListPrice price={store.salesTax} label="SalesTax" />

      <ListPrice price={store.shippingTax} label="ShippingTax" />
    </>
  );
});
